import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../Context/AuthContext'
import Loading from '../../../Common/Components/Loading'

interface GuestGuardProps {
  children: React.ReactNode
}

/**
 * ゲストガードコンポーネント
 * 
 * ログインページなど、認証済みユーザーがアクセスすべきでないページをラップし、
 * 認証済みの場合はホームページにリダイレクトする
 */
const GuestGuard: React.FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  // 認証状態を確認中はローディング表示
  if (isLoading) {
    return <Loading />
  }

  // 認証済みの場合はホームページ（または元のページ）にリダイレクト
  if (isAuthenticated) {
    const from = (location.state as any)?.from?.pathname || '/'
    return <Navigate to={from} replace />
  }

  return <>{children}</>
}

export default GuestGuard
